module.exports = __webpack_public_path__ + "img/ez-slot-guitar-card.88fc1459.png";